import React from 'react';

const stats = [
  { value: '98%', label: 'Data accuracy' },
  { value: '143M', label: 'Verified email addresses' },
  { value: '30%', label: 'Pick up rate on mobiles' },
];

export default function StatsBar() {
  return (
    <div className="bg-white border-y border-gray-100 py-10 mt-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {stats.map((stat, i) => (
            <div key={i} className="text-center">
              <p className="text-4xl lg:text-5xl font-extrabold text-indigo-600 mb-1">{stat.value}</p>
              <p className="text-sm text-gray-500 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
